export type { PublicConfig } from "@preptrack/contracts";

export const PUBLIC_CONFIG_QUERY_KEY = ["public", "config"] as const;
export const MAINTENANCE_REFRESH_INTERVAL_MS = 10_000;

export const isAdministrator = (roles: readonly string[] | undefined) =>
  roles?.includes("ADMIN") ?? false;

export const shouldShowMaintenance = (
  maintenanceEnabled: boolean,
  roles: readonly string[] | undefined,
) => maintenanceEnabled && !isAdministrator(roles);

export const shouldRevalidateSession = (
  wasMaintenanceEnabled: boolean | undefined,
  maintenanceEnabled: boolean,
  roles: readonly string[] | undefined,
) => wasMaintenanceEnabled === true && !maintenanceEnabled && !isAdministrator(roles);

export const isPausedRegistrationMode = (mode: string) =>
  mode === "register" || mode === "verify";
